import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AI_gif1 from "../../../assets/Recruitment/AI_1.gif";
import AI_3 from "../../../assets/Recruitment/AI_3.png";
import AI_gif5 from "../../../assets/Recruitment/A1_5.gif";
import AI_4 from "../../../assets/Recruitment/AI_4.png";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


export default function MgmtAccordion() {
  return (
    <div className="Accordian">
    
        <Accordion style={{ backgroundColor: "white" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography>
              <h3>Management</h3>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div
                id="management-challenge"
                style={{ backgroundColor: "white", color: "black" }}
              >
                <div className="challenge-content">
                  <h1
                    className="orange text-center"
                    style={{ color: "#f49221" }}
                  >
                    Management
                  </h1>
                  <p>
                    <span className="orange">
                      <b>Instructions:</b>
                    </span>
                    <br />
                    To be considered for the task phase, each candidate needs to
                    attempt the tasks specified under the categories{" "}
                    <b>Admin and Finance</b>, <b>Research</b> and{" "}
                    <b>Graphic Design</b>.
                    <br />
                    <b>At least one</b> of the tasks of the other categories{" "}
                    <b>(Video Editing and Web Development)</b> must be
                    attempted. These questions are an alternative method of
                    entry into the Project MANAS taskphase,<b> apart</b> from
                    the interviews.
                  </p>
                  <h2>
                    <u>Admin and Finance*</u>
                  </h2>
                  <p>
                    Project MANAS is participating in the IGVC 2026 competition at Oakland University, Michigan, USA. Create a plan for the logistics and accommodations for a team of 15 people attending the competition. As part of the management subsystem, outline the logistics, including accommodation, travel and hospitality, and create a comprehensive budget plan, justifying all decisions for budget allocation. Take into consideration the most efficient and cost-effective strategies for renting and utilizing trucks in the USA for transporting competition parts, considering factors such as truck sizes, rental policies, insurance requirements, and potential logistical challenges.
                    <br />
                    <b>NOTE</b>: You have been provided with all the details 6
                    months before the trip .
                  </p>
                  <h2>
                    <u>Research*</u>
                  </h2>
                  <p>
                    Project MANAS <b>requires 8 motors</b> fulfilling the
                    following specifications for the drone:
                    <ul style={{ marginLeft: "20px" }}>
                        <li>&#9679;Stepper Motor</li>
                        <li>&#9679;Size : Nema 24</li>
                        <li>&#9679;Number of phases: 2</li>
                        <li>&#9679;Holding Torque: min of 4.0Nm</li>
                        <li>&#9679;Encoder Type: Optical Incrementa</li>
                        <li>&#9679;Purpose: for Holonomic ground vehicle</li>
                    </ul>
                    <br />
                    <br />
                    Your task is to research two companies (ideally one
                    international and one indigenous) that manufacture a motor
                    that meet the above mentioned specifications. The research
                    must include, but not be limited to the following pointers:
                    <br />
                    <br />
                    <ol>
                      <li> Company's product reliability</li>
                      <li>Company’s partners and customers</li>
                      <li>
                        Company’s Location (considering shipping and delivery)
                      </li>
                    </ol>
                    A company that meets the best fit among the above mentioned
                    criteria needs to be shown, along with a{" "}
                    <b>properly structured plan</b> on how the same will be
                    purchased.
                  </p>
                  <h2>
                    <u>Graphic Design*</u>
                  </h2>
                  <p>
                    You have to do <b>at least one of the two</b> tasks
                    mentioned below:
                    <br />
                    <br />
                    <p>
                        Design an Instagram carousel post (4–8 slides) in the aesthetic of Minecraft, themed around:
“How to Survive Your First Year in College - Minecraft Edition”
Be creative and visually immersive, the post should feel like a crossover between real-life college advice and in-game Minecraft visuals.

                    </p>
                    <p>Each slide must include:</p>
                    <ul style={{ marginLeft: "20px" }}>
                      <li>&#9679;Pixelated design elements</li>
                      <li>&#9679;In-game inspired fonts (like Minecraftia or custom pixel fonts)</li>
                      <li>&#9679;Consistent layout and color palette (grass, dirt, inventory bar, XP bar, mobs, etc.)</li>
                      <li>&#9679;Provide real life advice, but through game mechanics (e.g., “Craft Your Social Circle”, “Avoid Creeper Energy”, “Food = Sleep + Maggi”)</li>
                      
                    </ul>
                    <p>Use photo-editing or vector tools to bring in real screenshots, manipulated textures, or create original Minecraft-style illustrations.</p>
                    <br/>
                    <p><b>Option B (Alternate):</b></p>
                    <p>Design a visually engaging travel dump Instagram post that captures the essence of a recent trip while showcasing your photo editing and graphic design skills. The post should consist of 4 to 8 slides, each creatively enhanced with design elements, overlays, filters, and visual storytelling.</p>
                    < p>
                        You are <b>recommended</b> to use Adobe Illustrator,
                        Adobe Photoshop and Figma to complete the task. If you
                        choose to use any other software, mention its name in
                        your submission.
                      </p>
                    

                    Installing Illustrator(For Windows users):
                    <br />
                    <a href="https://getintopc.com/softwares/graphic-design/adobe-illustrator-cc-2020-free-download-1062480/">
                      {" "}
                      https://getintopc.com/softwares/graphic-design/
                      <br />adobe-illustrator-cc-2020-free-download-1062480/
                    </a>
                    <br />
                    <br />
                    Installing Illustrator(For Mac ):
                    <br />
                    <a href="https://drive.google.com/drive/folders/1J2lLsf-_aqYtfPwKJ-fAWPFkTrG7z54W?usp=sharing">
                      {" "}
                      https://drive.google.com/drive/folders/
                      <br />1J2lLsf-_aqYtfPwKJ-fAWPFkTrG7z54W?usp=sharing
                    </a>
                    <br />
                    <br />
                    <b>NOTE:</b> Upload a drive link consisting of all your
                    previous work related to Graphic Design (if any).
                  </p>
                  <h2>
                    <u>Videography</u>
                  </h2>
                  <ul>
                    <li>
                        Create a video titled “A DAY IN THE LIFE OF AN MIT STUDENT” Decide on the main character (could be yourselves or a peer).                    <br />
                            
                    <br /> Focus on creativity, smoothness of transitions, and overall video quality.

                    </li>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>&#9679;Outline the day: Include typical routines like morning prep, attending classes, social time, meals at the canteen, extracurriculars, and evening wrap-up.</li>
                        <li>&#9679;Choose 3-5 key moments that bring out emotions (funny encounters, challenges, memorable events) and transition points (from classes to free time, from hustle to chill)</li>
                    </ul>
                  </ul>
                  <p>The video should:</p>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>&#9679;Include at least 4 campus locations</li>
                        <li>&#9679;Use quick jump cuts and energetic transitions to mimic trending Instagram styles</li>
                        <li>&#9679;Ensure the music matches the emotions and pacing of the scenes—softer tones during chill times, dynamic beats for active moments.</li>
                        <li>&#9679;Be edited with fast cuts, match cuts or clever transitions</li>
                        <li>&#9679;Maintain the Originality, relatability, influence on the viewer.</li>
                    </ul>
                  
                  You <b>SHOULD</b> use either of the following applications to
                  edit these videos.
                  <p>
                    
                    <br />
                    For Windows:
                    <br />
                    <br />
                    1. Premiere Pro
                    <br />
                    <a href="https://getintopc.com/softwares/video-editing/adobe-premiere-pro-2022-free-setup-download/">
                      https://getintopc.com/softwares/video-editing/
                      <br />adobe-premiere-pro-2022-free-setup-download/{" "}
                    </a>
                    <br />
                    2. DaVinci Resolve
                    <br />
                    <a href="https://www.blackmagicdesign.com/products/davinciresolve">
                      https://www.blackmagicdesign.com/products/
                      <br />davinciresolve{" "}
                    </a>
                    <br />
                    <br />
                    For Mac:
                    <br />
                    <br />
                    1. Premiere Pro
                    <br />
                    <a href="https://www.torrentmac.net/final-cut-pro-10-6-1/">
                      {" "}
                      https://www.torrentmac.net/final-cut-pro-10-6-1/{" "}
                    </a>
                    <br />
                    2. Final Cut Pro
                    <br />
                    <a href="https://www.torrentmac.net/adobe-premiere-pro-2021-v15-4-1/">
                      {" "}
                      https://www.torrentmac.net/adobe-premiere-pro-2021-v15-4-1/{" "}
                    </a>
                    <br />
                    2. DaVinci Resolve
                    <br />
                    <a href="https://www.blackmagicdesign.com/products/davinciresolve">
                      https://www.blackmagicdesign.com/products/
                      <br />davinciresolve{" "}
                    </a>
                    <br />
                    <br />
                    <b>NOTE:</b> Upload a drive link consisting of all your
                    previous work related to Video Editing (if any). If you use any other software, mention its name in your submission.
                  </p>
                  <h2>
                    <u>Web Development</u>
                  </h2>
                    <h3>Task: Build a Basic Homepage for <b>"Little Lemons" Restaurant</b></h3>

                    <h4><b>Objective:</b></h4>
                    <p>Create a clean, responsive homepage for a fictional restaurant named <b>Little Lemons</b> using HTML and CSS. JavaScript for small interactions is optional.</p>

                    <h4><b>Requirements:</b></h4>
                    <ol style={{ marginLeft: "20px" }}>
                        <li><b>Header Section</b>
                            <ul>
                                <li>&#9679;Restaurant name: <b>Little Lemons</b></li>
                                <li>&#9679;Navigation bar with at least 3 links: Home, Menu, Contact</li>
                                <li>&#9679;Background color or image that fits a restaurant theme</li>
                            </ul>
                        </li>
                        <li><b>Hero Section</b>
                            <ul>
                                <li>&#9679;Large welcoming heading: <i>"Fresh. Flavorful. Little Lemons."</i></li>
                                <li>&#9679;Short tagline/description (e.g., "Serving fresh Mediterranean flavors every day.")</li>
                                <li>&#9679;"Reserve a Table" button</li>
                            </ul>
                        </li>
                        <li><b>About Section</b>
                            <ul>
                                <li>&#9679;A brief paragraph about the restaurant’s story</li>
                                <li>&#9679;An image of fresh lemons or a dish</li>
                            </ul>
                        </li>
                        <li><b>Menu Preview Section</b>
                            <ul>
                                <li>&#9679;Display 3 featured dishes with:
                                    <ul style={{ marginLeft: "20px" }}>
                                        <li>&#8226;Dish name</li>
                                        <li>&#8226;Short description</li>
                                        <li>&#8226;Price</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li><b>Footer</b>
                            <ul >
                                <li>&#9679;Contact information (address, phone, email)</li>
                                <li>&#9679;Social media icons/links (optional)</li>
                            </ul>
                        </li>
                    </ol>

                    <h4><b>Bonus (Optional)</b></h4>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>&#9679;Try using React</li>
                        <li>&#9679;Make the page responsive using CSS Flexbox or Grid</li>
                        <li>&#9679;Add hover effects to buttons and menu items</li>
                        <li>&#9679;Include a Google Map embed of the restaurant location in the footer</li>
                    </ul>

                    

                    <h3><b>Deliverable</b></h3>
                    <p>A single-page website (or starter template) meeting the requirements above. Include any images in the <code>images/</code> folder and a separate <code>style.css</code> file.</p>
                   
                    <br />
                  <hr />
                  <br />
                  <h3>
                    <strong>Submission </strong>
                  </h3>
                  <p>
                    Email your answers and videos to{" "}
                    <a href="mailto:projectmanas.management@gmail.com ">
                      projectmanas.management@gmail.com
                    </a>
                    .
                  </p>
                  <p>
                    <b>NOTE: </b> The submissions over mail need to be
                    accompanied with the following details:
                    <ol>
                      <li>Full Name</li>
                      <li>Registration Number</li>
                      <li>Branch</li>
                      <li>Contact Number</li>
                    </ol>
                  </p>
                  <p>
                    {" "}
                    For any queries, please feel free to contact (Preferably
                    Whatsapp):{" "}
                  </p>
                  <div className="contact" align="center">
                    <p>
                      <b>Bedobrata Saikia </b>
                      <br /> +91 93878 61692
                      <br />
                    </p>
                    <p>
                      <b>Samya Kalsi </b>
                      <br /> +91 73473 85285
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
    </div>
    );
}